import { makeStyles } from '@material-ui/core'

import fonts from '@galo-monitor/styles/fonts'

export default makeStyles(() => ({
  cardTitle: {
    fontWeight: fonts.fontWeight.semiBold
  },
  cardValue: {
    fontWeight: fonts.fontWeight.bold
  }
}))
